export default __webpack_public_path__ + "static/media/icon-no-drone.40f2d935.webp";